import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";

import { cartSelectors } from "../../cart/_core/cartSelectors";
import { BentoPriceInfo } from "./BentoPriceInfo";
import { BentoProductQuantity } from "./BentoProductQuantity";
import { WidthRatioImageContainer } from "../../common/ratioContainers/WidthRatioImageContainer";
import { PRODUCT_TYPES } from "../../../api/products/productBaseConstants";
import { titleFormatter } from "../../../utils/titleFormatter";
import { ProductCode } from "../productCode/ProductCode";


export const BentoListItem = ({ bento, showAllBentos }) => {
  // const history = useHistory();
  // const open = () => history.push(`/rolls-detail/${poke.id}`);

  const cartItem = useSelector(state => cartSelectors.cartItem(state, bento));
  const productInCart = cartItem.count ? 'incart' : 'none';
  const currentDay = moment().day();
  console.log(currentDay);
  const isBentoForToday = bento.releaseDayOfWeek === currentDay;

  return (
    <>
      {(showAllBentos || isBentoForToday)
        ?  <li className="main-goods__list-item secondary-goods__list-item__stick" style={{padding: 0, scrollMarginTop: 120}} id={`bento-${bento.id}`} data-item={productInCart}>
              <div className="main-goods__item">
                <h3 className="main-goods__title">
                  <div>
                    <ProductCode code={bento.code}/>
                    <span>{titleFormatter(bento.title)}</span>
                  </div>
                  {isBentoForToday ? <span className="left-bento-label">сегодня</span> : null }
                </h3>

                <ul className="main-goods-types">
                  <BentoPriceInfo type="big" productType={bento.big}/>
                </ul>

                <WidthRatioImageContainer
                  ratio={1860 / 200}
                  publicImages={bento.publicImages}
                  type="main"
                  onClick={() => {}}
                  className="main-goods__picture"/>

                <BentoProductQuantity product={bento} type={PRODUCT_TYPES.bento.id} />

                <article className="main-goods__chars">
                  <p>{bento.get('announce')}</p>
                </article>
              </div>
           </li>
        : null
      }

      </>
  );
};
